module.exports = __webpack_public_path__ + "img/TurtleInCircle.9b5cec7a.svg";